// Montclair State University's bachelor's majors (#2839). Read on 2026-10-01
// from Montclair's official 2026-2027 University Catalog (catalog.montclair.edu,
// "2026-2027 Edition"; the catalog host answers only on http): every
// bachelor's program on each college's undergraduate Programs of Study tab,
// with the degree in the catalog's parentheses. The catalog lists
// concentrations and teacher-certification tracks as programs of their own,
// so they appear here as the catalog names them. Recording Arts and
// Production is listed by both the College of the Arts and the College of
// Communication and Media; it appears once, under the Arts, with a note. Two
// programs in the undergraduate Programs A-Z appear on no college page and
// keep their own group. Bloomfield College programs drop the catalog's
// " - Bloomfield College" suffix and sit in their own group. Left out:
// minors, certificates, combined bachelor's/master's entries and graduate
// programs.
const majors = {
    "slug": "montclair-state-university",
    "read": "2026-10-01",
    "intro": "Every bachelor's degree program in Montclair State University's official 2026-2027 University Catalog, grouped by the college or school that offers it, with the degree it leads to. Concentrations and teacher-certification tracks are listed the way the catalog lists them. Minors, certificates and graduate programs are left out.",
    "groups": [
        {
            "name": "College of the Arts",
            "source": {
                "label": "Montclair State University 2026-2027 University Catalog, College of the Arts",
                "url": "http://catalog.montclair.edu/colleges/arts/"
            },
            "majors": [
                {
                    "name": "Dance",
                    "degree": "B.F.A."
                },
                {
                    "name": "Dance - Education Concentration, with Teacher Certification in Dance (Preschool-Grade 12)",
                    "degree": "B.A."
                },
                {
                    "name": "Dance - Studio Teaching Concentration",
                    "degree": "B.A."
                },
                {
                    "name": "Fashion Design and Merchandising",
                    "degree": "B.A."
                },
                {
                    "name": "Graphic Design",
                    "degree": "B.F.A."
                },
                {
                    "name": "Illustration",
                    "degree": "B.F.A."
                },
                {
                    "name": "Music - Composition Concentration",
                    "degree": "B.Mus."
                },
                {
                    "name": "Music - Jazz Studies Concentration",
                    "degree": "B.Mus."
                },
                {
                    "name": "Music - Music Education Concentration with Teacher Certification in Music (Preschool-Grade 12)",
                    "degree": "B.Mus."
                },
                {
                    "name": "Music - Performance Concentration",
                    "degree": "B.Mus."
                },
                {
                    "name": "Music - School and Community Settings Concentration",
                    "degree": "B.Mus."
                },
                {
                    "name": "Music Therapy",
                    "degree": "B.A."
                },
                {
                    "name": "Musical Theatre",
                    "degree": "B.F.A."
                },
                {
                    "name": "Recording Arts and Production",
                    "degree": "B.A.",
                    "note": "Also listed by the College of Communication and Media."
                },
                {
                    "name": "Theatre - Acting Concentration",
                    "degree": "B.F.A."
                },
                {
                    "name": "Theatre - Design, Technology, and Management Concentration",
                    "degree": "B.F.A."
                },
                {
                    "name": "Theatre Studies",
                    "degree": "B.A."
                },
                {
                    "name": "Theatre Studies - Theatre Education Concentration, with Teacher Certification in Theatre (Preschool-Grade 12)",
                    "degree": "B.A."
                },
                {
                    "name": "Visual Arts",
                    "degree": "B.A."
                },
                {
                    "name": "Visual Arts - Art Education Concentration with Teacher Certification in Art (Preschool-Grade 12)",
                    "degree": "B.A."
                }
            ]
        },
        {
            "name": "Feliciano School of Business",
            "source": {
                "label": "Montclair State University 2026-2027 University Catalog, Feliciano School of Business",
                "url": "http://catalog.montclair.edu/colleges/business/"
            },
            "majors": [
                {
                    "name": "Accounting",
                    "degree": "B.S."
                },
                {
                    "name": "Business Administration with concentrations",
                    "degree": "B.S."
                },
                {
                    "name": "Business Analytics",
                    "degree": "B.S."
                },
                {
                    "name": "Economics",
                    "degree": "B.A."
                },
                {
                    "name": "Economics - Asset Management Concentration",
                    "degree": "B.A."
                },
                {
                    "name": "Entrepreneurship Concentration - Business Administration",
                    "degree": "B.S."
                },
                {
                    "name": "Finance Concentration - Business Administration",
                    "degree": "B.S."
                },
                {
                    "name": "Hospitality, Sports, Events, and Tourism",
                    "degree": "B.A."
                },
                {
                    "name": "International Business Concentration - Business Administration",
                    "degree": "B.S."
                },
                {
                    "name": "Management Concentration - Business Administration",
                    "degree": "B.S."
                },
                {
                    "name": "Management Information Systems Concentration - Business Administration",
                    "degree": "B.S."
                },
                {
                    "name": "Marketing Concentration - Business Administration",
                    "degree": "B.S."
                },
                {
                    "name": "Real Estate Concentration - Business Administration",
                    "degree": "B.S."
                },
                {
                    "name": "Strategic Human Capital Management Concentration - Business Administration",
                    "degree": "B.S."
                }
            ]
        },
        {
            "name": "College of Communication and Media",
            "source": {
                "label": "Montclair State University 2026-2027 University Catalog, College of Communication and Media",
                "url": "http://catalog.montclair.edu/colleges/communication-and-media/"
            },
            "majors": [
                {
                    "name": "Advertising",
                    "degree": "B.A."
                },
                {
                    "name": "Animation and Visual Effects",
                    "degree": "B.F.A."
                },
                {
                    "name": "Communication and Media Studies",
                    "degree": "B.A."
                },
                {
                    "name": "Film and Television",
                    "degree": "B.A."
                },
                {
                    "name": "Journalism and Digital Media",
                    "degree": "B.A."
                },
                {
                    "name": "Social Media and Public Relations",
                    "degree": "B.A."
                },
                {
                    "name": "Sports Communication",
                    "degree": "B.A."
                }
            ]
        },
        {
            "name": "College for Community Health",
            "source": {
                "label": "Montclair State University 2026-2027 University Catalog, College for Community Health",
                "url": "http://catalog.montclair.edu/colleges/community-health/"
            },
            "majors": [
                {
                    "name": "Child Advocacy and Policy",
                    "degree": "B.A."
                },
                {
                    "name": "Exercise Science",
                    "degree": "B.S."
                },
                {
                    "name": "Family Science and Human Development - Child and Lifespan Development Concentration",
                    "degree": "B.A."
                },
                {
                    "name": "Family Science and Human Development - Child and Lifespan Development Concentration with Teacher Certification in Elementary School Teacher in Grades K-6",
                    "degree": "B.A."
                },
                {
                    "name": "Family Science and Human Development - Child and Lifespan Development Concentration with Teacher Certification in Grades P-3",
                    "degree": "B.A."
                },
                {
                    "name": "Family Science and Human Development - Family and Human Services Concentration",
                    "degree": "B.A."
                },
                {
                    "name": "Nutrition and Food Science",
                    "degree": "B.S."
                },
                {
                    "name": "Nutrition and Food Science - Applied Wellness Concentration",
                    "degree": "B.S."
                },
                {
                    "name": "Nutrition and Food Science - Dietetics Concentration",
                    "degree": "B.S."
                },
                {
                    "name": "Nutrition and Food Science - Food Science Concentration",
                    "degree": "B.S."
                },
                {
                    "name": "Nutrition and Food Science - Sustainable Food Systems",
                    "degree": "B.S."
                },
                {
                    "name": "Physical Education - Physical Activity in Educational Settings Concentration",
                    "degree": "B.S."
                },
                {
                    "name": "Physical Education with Teacher Certification in Health and Physical Education (Preschool-Grade 12)",
                    "degree": "B.S."
                },
                {
                    "name": "Public Health - Health Education, Promotion, and Advocacy Concentration",
                    "degree": "B.S."
                },
                {
                    "name": "Public Health - Health Systems Administration and Policy Concentration",
                    "degree": "B.S."
                }
            ]
        },
        {
            "name": "College for Education and Engaged Learning",
            "source": {
                "label": "Montclair State University 2026-2027 University Catalog, College for Education and Engaged Learning",
                "url": "http://catalog.montclair.edu/colleges/education-engaged-learning/"
            },
            "majors": [
                {
                    "name": "Early Childhood Education",
                    "degree": "B.A."
                },
                {
                    "name": "Educational Foundations",
                    "degree": "B.A."
                },
                {
                    "name": "Educational Foundations with Teacher Certification in Grades K-6",
                    "degree": "B.A."
                },
                {
                    "name": "Elementary Education",
                    "degree": "B.A."
                },
                {
                    "name": "Secondary Education",
                    "degree": "B.A."
                }
            ]
        },
        {
            "name": "College of Humanities and Social Sciences",
            "source": {
                "label": "Montclair State University 2026-2027 University Catalog, College of Humanities and Social Sciences",
                "url": "http://catalog.montclair.edu/colleges/humanities-social-sciences/"
            },
            "majors": [
                {
                    "name": "Anthropology",
                    "degree": "B.A."
                },
                {
                    "name": "Anthropology with Teacher Certification in Elementary School Teacher in Grades K-6",
                    "degree": "B.A."
                },
                {
                    "name": "Arabic",
                    "degree": "B.A."
                },
                {
                    "name": "Asian Languages and Cultures - Chinese Concentration",
                    "degree": "B.A."
                },
                {
                    "name": "Asian Languages and Cultures - Japanese Concentration",
                    "degree": "B.A."
                },
                {
                    "name": "Asian Languages and Cultures - Korean Concentration",
                    "degree": "B.A."
                },
                {
                    "name": "Classics",
                    "degree": "B.A."
                },
                {
                    "name": "Computational Linguistics",
                    "degree": "B.S."
                },
                {
                    "name": "English",
                    "degree": "B.A."
                },
                {
                    "name": "English - Creative Writing Concentration",
                    "degree": "B.A."
                },
                {
                    "name": "English - Film Studies Concentration",
                    "degree": "B.A."
                },
                {
                    "name": "English with Teacher Certification in Elementary School Teacher in Grades K-6",
                    "degree": "B.A."
                },
                {
                    "name": "English with Teacher Certification in English (Preschool-Grade 12)",
                    "degree": "B.A."
                },
                {
                    "name": "French - French Civilization Concentration",
                    "degree": "B.A."
                },
                {
                    "name": "French - Translation Concentration",
                    "degree": "B.A."
                },
                {
                    "name": "French with Teacher Certification in French (Preschool-Grade 12)",
                    "degree": "B.A."
                },
                {
                    "name": "Gender, Sexuality, and Women's Studies",
                    "degree": "B.A."
                },
                {
                    "name": "Gender, Sexuality, and Women's Studies with Teacher Certification in Elementary School Teacher in Grades K-6",
                    "degree": "B.A."
                },
                {
                    "name": "German",
                    "degree": "B.A."
                },
                {
                    "name": "History",
                    "degree": "B.A."
                },
                {
                    "name": "History - Public and Digital History Concentration",
                    "degree": "B.A."
                },
                {
                    "name": "History with Teacher Certification in Elementary School Teacher in Grades K-6",
                    "degree": "B.A."
                },
                {
                    "name": "History with Teacher Certification in Social Studies (Preschool-Grade 12)",
                    "degree": "B.A."
                },
                {
                    "name": "Humanities",
                    "degree": "B.A."
                },
                {
                    "name": "Humanities - Comparative Myth and Literature Concentration",
                    "degree": "B.A."
                },
                {
                    "name": "Humanities with Teacher Certification in Elementary School Teacher in Grades K-6",
                    "degree": "B.A."
                },
                {
                    "name": "Interdisciplinary Studies - Health and Wellness Concentration",
                    "degree": "B.A."
                },
                {
                    "name": "Interdisciplinary Studies - Human Values and Problem Solving Concentration",
                    "degree": "B.A."
                },
                {
                    "name": "Interdisciplinary Studies - Technology, Self, and Society Concentration",
                    "degree": "B.A."
                },
                {
                    "name": "Italian",
                    "degree": "B.A."
                },
                {
                    "name": "Italian with Teacher Certification in Italian (Preschool-Grade 12)",
                    "degree": "B.A."
                },
                {
                    "name": "Jurisprudence, Law, and Society",
                    "degree": "B.A."
                },
                {
                    "name": "Justice Studies - Criminal Justice Concentration",
                    "degree": "B.A."
                },
                {
                    "name": "Justice Studies - International Justice Concentration",
                    "degree": "B.A."
                },
                {
                    "name": "Language, Business, and Culture",
                    "degree": "B.A."
                },
                {
                    "name": "Latin",
                    "degree": "B.A."
                },
                {
                    "name": "Latin with Teacher Certification in Latin (Preschool-Grade 12)",
                    "degree": "B.A."
                },
                {
                    "name": "Linguistics",
                    "degree": "B.A."
                },
                {
                    "name": "Linguistics - Language Engineering Concentration",
                    "degree": "B.A."
                },
                {
                    "name": "Linguistics with Teacher Certification in English as a Second Language (Preschool-Grade 12)",
                    "degree": "B.A."
                },
                {
                    "name": "Medical Humanities",
                    "degree": "B.A."
                },
                {
                    "name": "Philosophy",
                    "degree": "B.A."
                },
                {
                    "name": "Policy Studies",
                    "degree": "B.A."
                },
                {
                    "name": "Political Science",
                    "degree": "B.A."
                },
                {
                    "name": "Political Science with Teacher Certification in Social Studies (Preschool-Grade 12)",
                    "degree": "B.A."
                },
                {
                    "name": "Psychology",
                    "degree": "B.A."
                },
                {
                    "name": "Psychology with Teacher Certification in Elementary School Teacher in Grades K-6",
                    "degree": "B.A."
                },
                {
                    "name": "Psychology with Teacher Certification in Social Studies (Preschool-Grade 12)",
                    "degree": "B.A."
                },
                {
                    "name": "Public and Professional Writing",
                    "degree": "B.A."
                },
                {
                    "name": "Religious Studies",
                    "degree": "B.A."
                },
                {
                    "name": "Religious Studies with Teacher Certification in Elementary School Teacher in Grades K-6",
                    "degree": "B.A."
                },
                {
                    "name": "Sociology",
                    "degree": "B.A."
                },
                {
                    "name": "Sociology with Teacher Certification in Elementary School Teacher in Grades K-6",
                    "degree": "B.A."
                },
                {
                    "name": "Sociology with Teacher Certification in Social Studies (Preschool-Grade 12)",
                    "degree": "B.A."
                },
                {
                    "name": "Spanish",
                    "degree": "B.A."
                },
                {
                    "name": "Spanish - Translation Concentration",
                    "degree": "B.A."
                },
                {
                    "name": "Spanish with Teacher Certification in Elementary School Teacher in Grades K-6",
                    "degree": "B.A."
                },
                {
                    "name": "Spanish with Teacher Certification in Spanish (Preschool-Grade 12)",
                    "degree": "B.A."
                },
                {
                    "name": "Sustainable Urban Communities",
                    "degree": "B.A."
                }
            ]
        },
        {
            "name": "School of Nursing",
            "source": {
                "label": "Montclair State University 2026-2027 University Catalog, School of Nursing",
                "url": "http://catalog.montclair.edu/colleges/nursing/"
            },
            "majors": [
                {
                    "name": "Nursing",
                    "degree": "B.S.N."
                },
                {
                    "name": "Nursing, R.N. to B.S.N.",
                    "degree": "B.S.N.",
                    "note": "For registered nurses completing a bachelor's degree."
                }
            ]
        },
        {
            "name": "College of Science and Mathematics",
            "source": {
                "label": "Montclair State University 2026-2027 University Catalog, College of Science and Mathematics",
                "url": "http://catalog.montclair.edu/colleges/science-mathematics/"
            },
            "majors": [
                {
                    "name": "Applied Mathematics and Statistics",
                    "degree": "B.S."
                },
                {
                    "name": "Biochemistry",
                    "degree": "B.S."
                },
                {
                    "name": "Biology",
                    "degree": "B.A."
                },
                {
                    "name": "Biology - Environmental Science Concentration",
                    "degree": "B.S."
                },
                {
                    "name": "Biology - General Studies Concentration",
                    "degree": "B.S."
                },
                {
                    "name": "Biology - Pre-Medical Professions Concentration",
                    "degree": "B.S."
                },
                {
                    "name": "Biology - Research Concentration",
                    "degree": "B.S."
                },
                {
                    "name": "Biology with Teacher Certification in Biological Science (Preschool-Grade 12)",
                    "degree": "B.S."
                },
                {
                    "name": "Chemistry",
                    "degree": "B.S."
                },
                {
                    "name": "Chemistry - Business Concentration",
                    "degree": "B.S."
                },
                {
                    "name": "Chemistry with Teacher Certification in Chemistry (Preschool-Grade 12)",
                    "degree": "B.S."
                },
                {
                    "name": "Computer Science",
                    "degree": "B.S."
                },
                {
                    "name": "Data Science",
                    "degree": "B.S."
                },
                {
                    "name": "Earth and Environmental Science",
                    "degree": "B.S."
                },
                {
                    "name": "Earth and Environmental Science with Teacher Certification in Earth Science (Preschool-Grade 12)",
                    "degree": "B.S."
                },
                {
                    "name": "Geographic, Environmental, and Urban Studies",
                    "degree": "B.A."
                },
                {
                    "name": "Geography with Teacher Certification in Social Studies (Preschool-Grade 12)",
                    "degree": "B.A."
                },
                {
                    "name": "Information Technology",
                    "degree": "B.S."
                },
                {
                    "name": "Marine Biology and Coastal Sciences",
                    "degree": "B.S."
                },
                {
                    "name": "Mathematics",
                    "degree": "B.S."
                },
                {
                    "name": "Mathematics - Mathematics Education Concentration with Teacher Certification in Mathematics (Preschool - Grade 12)",
                    "degree": "B.S."
                },
                {
                    "name": "Mathematics with Teacher Certification in Elementary School Teacher in Grades K-6",
                    "degree": "B.S."
                },
                {
                    "name": "Molecular Biology",
                    "degree": "B.S."
                },
                {
                    "name": "Physics",
                    "degree": "B.S."
                },
                {
                    "name": "Physics - Astronomy Concentration",
                    "degree": "B.S."
                },
                {
                    "name": "Physics with Teacher Certification in Physical Science (Preschool-Grade 12)",
                    "degree": "B.S."
                },
                {
                    "name": "Sustainability Science",
                    "degree": "B.S."
                }
            ]
        },
        {
            "name": "Bloomfield College of Montclair State University",
            "source": {
                "label": "Montclair State University 2026-2027 University Catalog, Bloomfield College of Montclair State University",
                "url": "http://catalog.montclair.edu/colleges/bloomfield-college/"
            },
            "note": "Bloomfield College of Montclair State University has its own admissions office, and Montclair posts a separate Common Data Set for it.",
            "majors": [
                {
                    "name": "Applied Biological Sciences",
                    "degree": "B.S."
                },
                {
                    "name": "Applied Studies - Public Service Concentration",
                    "degree": "B.A."
                },
                {
                    "name": "Creative Arts & Technology - 2D Animation Concentration",
                    "degree": "B.A."
                },
                {
                    "name": "Creative Arts & Technology - Graphic Design Concentration",
                    "degree": "B.A."
                },
                {
                    "name": "Creative Arts & Technology - Music Technology Concentration",
                    "degree": "B.A."
                },
                {
                    "name": "Creative Arts and Technology - 3D Animation Concentration",
                    "degree": "B.A."
                },
                {
                    "name": "Creative Arts and Technology - Game Development and Design Concentration",
                    "degree": "B.A."
                },
                {
                    "name": "Criminology & Social Justice",
                    "degree": "B.A."
                },
                {
                    "name": "Game Programming",
                    "degree": "B.S."
                },
                {
                    "name": "Informatics",
                    "degree": "B.S."
                },
                {
                    "name": "Nursing",
                    "degree": "B.S."
                },
                {
                    "name": "Psychology",
                    "degree": "B.A."
                },
                {
                    "name": "Sociology",
                    "degree": "B.A."
                }
            ]
        },
        {
            "name": "Listed in the catalog's Programs A-Z only",
            "source": {
                "label": "Montclair State University 2026-2027 University Catalog, Programs A-Z",
                "url": "http://catalog.montclair.edu/programs/"
            },
            "note": "These bachelor's programs appear in the catalog's undergraduate Programs A-Z but on no college page.",
            "majors": [
                {
                    "name": "Liberal Studies",
                    "degree": "B.A.",
                    "note": "Fully online, for working adults over 25 finishing a degree."
                },
                {
                    "name": "Physics with Teacher Certification in Physics (Preschool-Grade 12)",
                    "degree": "B.S."
                }
            ]
        }
    ]
};

export default majors;
